import { render, staticRenderFns } from "./standart-category-form.vue?vue&type=template&id=0b3bf4a8&"
import script from "./standart-category-form.vue?vue&type=script&lang=ts&"
export * from "./standart-category-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports